import tagularModule from './../store/helpers/tagular'

const createRelatedArticleTrackingEvents = element => {
  const articleLink = element.querySelector('[data-article-card-text]')

  articleLink.addEventListener('click', function() {
    console.log('click')
    let articleText = articleLink.dataset.articleCardText

    const webElement = {
      location: 'You may also like',
      position: 'footer',
      elementType: 'link',
      text: articleText,
      htmlId: ''
    }

    const actionOutcome = 'INTERNALLINK'
    const outboundUrl = ''
    const correlationId = ''

    tagularModule.elementClicked(
      webElement,
      actionOutcome,
      outboundUrl,
      correlationId,
      'redventures.usertracking.v3.ElementClicked'
    )
  })
}

const bindRelatedArticleTrackingEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createRelatedArticleTrackingEvents(element)
    })
  }
}

bindRelatedArticleTrackingEvents('[data-article-card]')
